import React from "react";
import Header from "./Components/Header/Header";
import HeroSection from "./Components/Hero/HeroSection";
import Education from "./Components/Education/Education";
import BackToTop from "./Components/BackToTop/BackToTop";
import Research from "./Components/Research/Research";
import Footer from "./Components/Footer/Footer";

import "./App.css";

function App() {
  return (
    <div className="main-wrapper">
      <Header />
       <HeroSection />
      {/* <About /> */}
      <Education />
      <Research />
      <Footer /> 
      <BackToTop />

    </div>
  );
}

export default App;
